import React from 'react';

/* eslint-disable react/prop-types */

export default function ({ color }) {
	// viewBox 0 0 12 12
	return (
		<g fill={color}>
			<path d="M.9.72C.78.72.7.8.7.9v8.37c0 .1.09.18.2.18h3.26c.2 0 .35.16.35.36 0 .2-.15.36-.35.36H.89a.9.9 0 0 1-.89-.9V.9C0 .4.4 0 .9 0h10.2c.5 0 .9.4.9.9v8.37c0 .5-.4.9-.9.9H7.94a.36.36 0 0 1-.36-.36c0-.2.16-.36.36-.36h3.18c.1 0 .18-.08.18-.18V.9c0-.1-.08-.18-.18-.18z" />
			<path d="M6 3.73a2.48 2.48 0 0 0-2.46 2.5 2.46 2.46 0 1 0 4.92-.02c0-1.38-1.1-2.48-2.46-2.48zm-3.03 2.5c0-1.7 1.36-3.07 3.03-3.07s3.03 1.37 3.03 3.06S7.67 9.3 6 9.3 2.97 7.9 2.97 6.22z" />
			<path d="M6 8.8c.26 0 .47.21.47.48v2.24c0 .27-.2.48-.47.48a.48.48 0 0 1-.47-.48V9.28c0-.27.2-.48.47-.48zM2.78 5.92H2.2v2.56h1.32v-.17a3.29 3.29 0 0 1-.74-2.4zm1.45-.59v2.3c.32.41.78.72 1.3.84V5.33Zm2.02-.68v3.82c.5-.06.96-.28 1.31-.62v-3.2H6.25Zm3.33-1.2h-1.3v.45a3.28 3.28 0 0 1 .05 4.59h1.25zm2.07-.99H.35V1.9h11.3ZM10.4 1.6c.18 0 .32-.15.32-.33a.32.32 0 0 0-.32-.32.32.32 0 0 0-.32.32c0 .18.15.32.32.32zm-1.2 0c.19 0 .33-.15.33-.33A.32.32 0 0 0 9.2.95a.32.32 0 0 0-.32.32c0 .18.14.32.32.32zM8 1.6c.19 0 .33-.15.33-.33A.32.32 0 0 0 8 .95a.32.32 0 0 0-.32.32c0 .18.14.32.32.32z" />
		</g>
	);
}
